module.exports = "/images/hk.svg?08cc0e1dc1332f545f503c0041f12465";